import type { ATractorAd } from "@mobility-item-page/types";
import { isPrivateAdvertiser } from "@mobility-item-page/utilities";
import { AdPlacement } from "@schibsted-nmp/advertising-companion";
import { useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import type { AdProps } from "../components/Ad.tsx";
import AdReport from "../components/AdReport.tsx";
import {
  AdvertisingContainer,
  FinancingAdvertisingPlacement1,
  MobileOnlyFinancingAdvertisingPlacements,
} from "../components/advertising/AdvertisingPlacement.tsx";
import ComplaintClaim from "../components/complaint-claim/ComplaintClaim.tsx";
import { DesktopCompanyProfile, EnabledDealerOverview, MobileCTAs } from "../components/Dealer.tsx";
import Description from "../components/Description.tsx";
import Disclaimer from "../components/Disclaimer.tsx";
import { Equipment } from "../components/Equipment.tsx";
import { FeedbackForm } from "../components/FeedbackForm.tsx";
import { FinanceSection } from "../components/finance-section/FinanceSection.tsx";
import { Layout } from "../components/Layout.tsx";
import LocationSection from "../components/location/LocationSection.tsx";
import Price from "../components/Price.tsx";
import { PrivateSeller } from "../components/PrivateSeller.tsx";
import SearchLinks from "../components/SearchLinks.tsx";
import SafetyElements from "../components/safety-elements/Index.tsx";
import { Summary } from "../components/section-summary/SectionSummary.tsx";
import { ATractorSpecifications } from "../components/specification/atractor/ATractorSpecifications.tsx";
import Title from "../components/Title.tsx";
import UsefulResources from "../components/UsefulResources.tsx";
import { SignupAlert } from "../components/user-panel-signup/SignupAlert.tsx";

type Props = AdProps & {
  ad: ATractorAd;
};

export const ATractor = ({ ad }: Props) => {
  const { isMobile, enableFeedback } = useAppConfig();

  const { ownerUrn } = useAdViewMeta();
  const isPrivateAd = isPrivateAdvertiser(ownerUrn);
  return (
    <Layout
      left={
        <>
          <Title title={ad.title} statusText={ad.disposed_text} />
          <Summary ad={ad} />
          <Price />
          <MobileCTAs />
          <FinancingAdvertisingPlacement1 />
          {isMobile && <MobileOnlyFinancingAdvertisingPlacements />}
        </>
      }
      leftBottom={
        <>
          <FinanceSection />
          <Description description={ad.description_unsafe} loanWarningLink={ad.loan_warning_link} />
          {isMobile && <AdvertisingContainer placement={AdPlacement.AdvtMiddle2} className="mt-40" />}
          <ATractorSpecifications ad={ad} />
          <Equipment equipment={ad.equipment} />
          <SafetyElements />
          <ComplaintClaim />
          <LocationSection />
          {isMobile && <AdvertisingContainer placement={AdPlacement.AdvtMiddle2} className="mt-40" />}
          {isMobile && <UsefulResources />}
          {isMobile && <SignupAlert adViewType={ad.adViewType} />}
        </>
      }
      right={
        <>
          {isPrivateAd && <PrivateSeller adviewtype={ad.adViewType} />}
          <DesktopCompanyProfile />
          {!isMobile && <UsefulResources />}
          {!isMobile && <SignupAlert adViewType={ad.adViewType} />}
          {!isMobile && <AdvertisingContainer placement={AdPlacement.AdvtMiddle1} className={"mt-24"} />}
          {!isMobile && <AdvertisingContainer placement={AdPlacement.AdvtArticle1} className={"mt-24"} />}
          {!isMobile && <AdvertisingContainer placement={AdPlacement.AdvtArticle2} className={"mt-24"} />}
        </>
      }
      bottomWide={
        <>
          {!isPrivateAd && <EnabledDealerOverview />}
          <AdReport />
          <Disclaimer />
          <SearchLinks />
          {enableFeedback && <FeedbackForm />}
        </>
      }
    />
  );
};
